import { createRouter, createWebHistory } from "vue-router";
import AuthTemplate from "@/components/authentication/AuthTemplate";
import LoginAccount from "@/components/authentication/LoginAccount";
import ForgotPassword from "@/components/authentication/ForgotPassword";
import ResetPassword from "@/components/authentication/ResetPassword";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import MyDashboard from "@/components/dashboard/MyDashboard";
import companyView from "@/components/companyList/companyView";
import NewCompany from "@/components/company/NewCompany";
import SignUp from "@/components/signUp/SignUp";
import VerifyEmail from "@/components/signUp/VerifyEmail";
import NewBrand from "@/components/Brands/NewBrand.vue"
import ActivateAccount from "@/components/ActivateAccount/ActivateAccount"

import SuppliersView from "@/components/suppliers/SuppliersView";
import NewSupplier from "@/components/suppliers/SuppliersNew/NewSupplier";
import SupplierEdit from "@/components/suppliers/SuppliersEdit/SupplierEdit";
import SupplieView from "@/components/suppliers/SuppliersEdit/SupplierEdit";
import BrandsMenu from "@/components/Brands/BrandsMenu.vue";
import SupplierClient from "@/components/SupplierClient/SupplierClient";

import PurchaseOrder from "@/components/PurchaseOrder/PurchaseOrderMenu";

import Invoices from "@/components/Invoices/InvoicesMenu";
import NewInvoice from "@/components/Invoices/NewInvoice"

import Permissions from "@/components/Permissions/PermissionsView"
import NewRole from "@/components/Permissions/NewRole"
import RoleEdit from "@/components/Permissions/EditRole/EditRoleMenu"
import ProductsMenu from "@/components/products/ProductsMenu.vue";
import NewProductCatalog from "@/components/products/NewProductCatalog.vue";
import ClientsMenu from "@/components/Clients/ClientsMenu.vue";
import ClientsDetails from "@/components/Clients/ClientEdit/ClientsDetails.vue";
import CategoriesView from "@/components/Categories/CategoriesView";
import SubCategories from "@/components/Categories/SubCategories";

import EditProduct from "@/components/products/EditProduct.vue";
import PriceListMenu from "@/components/products/PriceList/PriceListMenu.vue";

import CategoryDetails from "@/components/Categories/CategoryDetails.vue";
import AdministrationMenu from "@/components/AdministrationMenu/AdministrationMenu.vue";
import ProductsValidation from "@/components/products/ProductsValidation.vue";

import OrdersView from "@/components/Orders/OrdersView.vue";
import OrderDetails from '@/components/Orders/OrderDetails.vue';
import OrderPurchaseOrder from "@/components/Orders/OrdersEdit/OrderPurchaseOrder.vue";
import DeliveryMenu from "@/components/Deliveries/DeliveryMenu.vue";
import DeliveriesList from "@/components/Deliveries/DeliveriesList.vue";
import NewDelivery from "@/components/Deliveries/NewDelivery.vue";
import DelvriesActionMenu from "@/components/Deliveries/DelvriesActionMenu.vue";
import DelivryCompanyDetails from "@/components/Deliveries/DelivryCompanyDetails.vue";
import DeliveryCompanyGeneralInformation from "@/components/Deliveries/DeliveryCompanyGeneralInformation.vue";
import DelivryPersonsList from "@/components/Deliveries/DeliveryPersons/DelivryPersonsList.vue";
import DeliveryPersonsMenu from "@/components/Deliveries/DeliveryPersons/DeliveryPersonsMenu.vue";
import NewDeliveryPerson from "@/components/Deliveries/DeliveryPersons/NewDeliveryPerson.vue";
import DeliveryVehiculesList from "@/components/Deliveries/DeliveryVehicules/DeliveryVehiculesList.vue";
import NewVehicle from "@/components/Deliveries/DeliveryVehicules/NewVehicle.vue";
import DeliveryCompanyOrderList from "@/components/Deliveries/DeliveryCompanyOrder/DeliveryCompanyOrderList.vue";
import ProductTypeMenu from "@/components/ProductType/ProductTypeMenu.vue";

import DelivryOrdersMenu from "@/components/DelivryOrders/DelivryOrdersMenu.vue";
import DelivryOrdersList from "@/components/DelivryOrders/DelivryOrdersList.vue";
import DelivryOrdersActionMenu from "@/components/DelivryOrders/DelivryOrdersActionMenu.vue";
import DeliveryClientOrdersMenu from "@/components/DelivryOrders/DeliveryClientOrdersMenu.vue";
import DeliveryClientOrdersList from "@/components/DelivryOrders/DeliveryClientOrdersList.vue";
import DeliveryClientOrdersActionMenu from "@/components/DelivryOrders/DeliveryClientOrdersActionMenu.vue";
import DeliveryClientOrdersDetails from "@/components/DelivryOrders/DeliveryClientOrdersDetails.vue";
import DeliveryPersonsActionMenu from "@/components/Deliveries/DeliveryPersons/DeliveryPersonsActionMenu.vue";
import DeliveryVehiculesActionMenu from "@/components/Deliveries/DeliveryVehicules/DeliveryVehiculesActionMenu.vue";
import AuthDeliveryTemplate from "@/components/DeliveryAuth/AuthDeliveryTemplate";
import LoginDelivery from "@/components/DeliveryAuth/LoginDelivery";

import MasterOrdersView from "@/components/MasterOrders/MasterOrdersView.vue";
import MasterOrderDetailsView from "@/components/MasterOrders/MasterOrderDetails/MasterOrderDetailsView.vue";

import PickupPointMenu from "@/components/PickupPoint/PickupPointMenu.vue";

import initializedDeliveryOrders from "@/components/DelivryOrders/initializedDeliveryOrders/initializedDeliveryOrdersMenu.vue";

import PicPhonePrivacyPolicy from "@/components/PicPhonePrivacyPolicy/PicPhonePrivacyPolicy.vue";

import BilGrosPrivacyPolicy from "@/components/PrivacyPolicy/BilGrosPrivacyPolicy.vue";

import SupportClient from "@/components/Support/SupportClient.vue";
import DeleteAccount from "@/components/Support/DeleteAccount.vue";

const routes = [
    {
        path: "/",
        name: "Authentification",
        component: AuthTemplate,
        children: [
            {
                path: "/",
                name: "login",
                component: LoginAccount,
            },
            {
                path: "/ForgotPassword",
                name: "ForgotPassword",
                component: ForgotPassword,
            },
            {
                path: "/ResetPassword",
                name: "ResetPassword",
                component: ResetPassword,
            },
            {
                path: "/SignUp",
                name: "SignUp",
                component: SignUp,
            },
            {
                path: "/VerifyEmail/:email",
                name: "VerifyEmail",
                component: VerifyEmail,
            },
            {
                path: "/ActivateAccount",
                name: "ActivateAccount",
                component: ActivateAccount,
            },
        ],
    },
    {
        path: "/",
        name: "AuthentificationDelivery",
        component: AuthDeliveryTemplate,
        children: [
            {
                path: "/Deliverylogin",
                name: "Deliverylogin",
                component: LoginDelivery,
            },
        ],
    },
    {
        path: "/",
        name: "DashboardLayout",
        component: DashboardLayout,
        meta: {
            auth: true,
        },
        children: [
            {
                path: "/MyDashboard",
                name: "MyDashboard",
                component: MyDashboard,
            },
            {
                path: "/NewCompany",
                name: "NewCompany",
                component: NewCompany,
            },
            {
                path: "/Configuration",
                name: "Configuration",
                component: companyView,
            },
            {
                path: "/suppliers",
                name: "Suppliers",
                component: SuppliersView,
            },
            {
                path: "/clients",
                name: "Clients",
                component: ClientsMenu,
            },
            {
                path: "/orders",
                name: "Orders",
                component: OrdersView,
            },
            {
                path: "/masterOrders",
                name: "MasterOrders",
                component: MasterOrdersView,
            },
            {
                path: "/masterOrderDetails/:id",
                name: "MasterOrderDetails",
                component: MasterOrderDetailsView,
                props: true,
            },
            {
                path: "/orders/:orderId/purchaseOrder",
                name: "OrderPurchaseOrder",
                component: OrderPurchaseOrder,
                props: true,
            },
            {
                path: "/orders/:id",
                name: "OrderDetails",
                component: OrderDetails,
            },
            {
                path: "/ClientsDetails/:id",
                name: "ClientsDetails",
                component: ClientsDetails,
            },
            {
                path: "/supplier",
                name: "Supplier",
                component: SupplieView,
            },
            {
                path: "/suppliersadd",
                name: "NewSupplier",
                component: NewSupplier,
            },
            {
                path: "/suppliersEdit/:id",
                name: "SuppliersEdit",
                component: SupplierEdit,
            },
            {
                path: "/PurchaseOrder",
                name: "PurchaseOrder",
                component: PurchaseOrder,
            },
            {
                path: "/Invoices",
                name: "Invoices",
                component: Invoices,
            },
            {
                path: "/NewInvoice",
                name: "NewInvoice",
                component: NewInvoice,
            },
            {
                path: "/Permissions",
                name: "Permissions",
                component: Permissions,
            },
            {
                path: "/NewRole",
                name: "NewRole",
                component: NewRole,
            },
            {
                path: "/RoleEdit/:id",
                name: "RoleEdit",
                component: RoleEdit,
            },
            {
                path: "/Client",
                name: "Client",
                component: SupplierClient,
            },
            {
                path: "/products",
                name: "Products",
                component: ProductsMenu,
            },
            {
                path: "/newProduct",
                name: "NewProduct",
                component: NewProductCatalog,
            },
            {
                path: "/Categories",
                name: "Categories",
                component: CategoriesView,
            },
            {
                path: "/Categories/:categoryId/SubCategories",
                name: "SubCategories",
                component: SubCategories,
                props: true,
            },
            {
                path: "/BrandsMenu",
                name: "BrandsMenu",
                component: BrandsMenu,
                props: true,
            },
            {
                path: "/NewBrand",
                name: "NewBrand",
                component: NewBrand,
                props: true,
            },
            {
                path: "/ProductTypeMenu",
                name: "ProductTypeMenu",
                component: ProductTypeMenu,
                props: true,
            },
            {
                path: "/productEdit/:id",
                name: "ProductEdit",
                component: EditProduct,
            },
            {
                path: "/productPriceList/:id",
                name: "ProductPriceList",
                component: PriceListMenu,
            },
            {
                path: "/Categories/category-details/:id",
                name: "CategoryDetails",
                component: CategoryDetails,
                props: true,
            },
            {
                path: "/AdministrationMenu",
                name: "AdministrationMenu",
                component: AdministrationMenu,
                props: true,
            },
            {
                path: "/ProductsValidation/:id",
                name: "ProductsValidation",
                component: ProductsValidation,
                props: true,
            },
            {
                path: "/DeliveryMenu",
                name: "DeliveryMenu",
                component: DeliveryMenu,
                props: true,
            },
            {
                path: "/DeliveriesList",
                name: "DeliveriesList",
                component: DeliveriesList,
                props: true,
            },
            {
                path: "/NewDelivery",
                name: "NewDelivery",
                component: NewDelivery,
                props: true,
            },
            {
                path: "/DelvriesActionMenu",
                name: "DelvriesActionMenu",
                component: DelvriesActionMenu,
                props: true,
            },
            {
                path: "/DelivryCompanyDetails/:id",
                name: "DelivryCompanyDetails",
                component: DelivryCompanyDetails,
                props: true,
            },
            {
                path: "/MyDeliveryCompany",
                name: "MyDeliveryCompany",
                component: DelivryCompanyDetails,
                props: true,
            },
            {
                path: "/DeliveryCompanyGeneralInformation",
                name: "DeliveryCompanyGeneralInformation",
                component: DeliveryCompanyGeneralInformation,
                props: true,
            },
            {
                path: "/DelivryPersonsList",
                name: "DelivryPersonsList",
                component: DelivryPersonsList,
                props: true,
            },
            {
                path: "/DeliveryPersonsMenu",
                name: "DelivDeliveryPersonsMenuryPersonsList",
                component: DeliveryPersonsMenu,
                props: true,
            },
            {
                path: "/NewDeliveryPerson",
                name: "NewDeliveryPerson",
                component: NewDeliveryPerson,
                props: route => ({ deliveryCompanyId: route.query.deliveryCompanyId })
            },
            {
                path: "/DeliveryVehiculesList",
                name: "DeliveryVehiculesList",
                component: DeliveryVehiculesList,
                props: true,
            },
            {
                path: "/NewVehicle",
                name: "NewVehicle",
                component: NewVehicle,
                props: true,
            },
            {
                path: "/DeliveryCompanyOrderList",
                name: "DeliveryCompanyOrderList",
                component: DeliveryCompanyOrderList,
                props: true,
            },
            {
                path: "/DelivryOrdersMenu",
                name: "DelivryOrdersMenu",
                component: DelivryOrdersMenu,
                props: true,
            },
            {
                path: "/DelivryOrdersList",
                name: "DelivryOrdersList",
                component: DelivryOrdersList,
                props: true,
            },
            {
                path: "/DelivryOrdersActionMenu",
                name: "DelivryOrdersActionMenu",
                component: DelivryOrdersActionMenu,
                props: true,
            },
            {
                path: "/DeliveryClientOrdersMenu/:id",
                name: "DeliveryClientOrdersMenu",
                component: DeliveryClientOrdersMenu,
                props: true,
            },
            {
                path: "/DeliveryClientOrdersList",
                name: "DeliveryClientOrdersList",
                component: DeliveryClientOrdersList,
                props: true,
            },
            {
                path: "/DeliveryClientOrdersActionMenu",
                name: "DeliveryClientOrdersActionMenu",
                component: DeliveryClientOrdersActionMenu,
                props: true,
            },
            {
                path: "/DeliveryClientOrdersDetails/:id",
                name: "DeliveryClientOrdersDetails",
                component: DeliveryClientOrdersDetails,
                props: true,
            },
            {
                path: "/DeliveryPersonsActionMenu/:id",
                name: "DeliveryPersonsActionMenu",
                component: DeliveryPersonsActionMenu,
                props: true,
            },
            {
                path: "/DeliveryVehiculesActionMenu/",
                name: "DeliveryVehiculesActionMenu",
                component: DeliveryVehiculesActionMenu,
                props: true,
            },
            {
                path: "/PickupPointMenu",
                name: "PickupPointMenu",
                component: PickupPointMenu,
                props: true,
            },
            {
                path: "/initializedDeliveryOrders",
                name: "initializedDeliveryOrders",
                component: initializedDeliveryOrders,
                props: true,
            }
        ],
    },
    {
        path: "/SupportClient",
        name: "SupportClient",
        component: SupportClient,
    },
    {
        path: "/DeleteAccount",
        name: "DeleteAccount",
        component: DeleteAccount,
    },
    {
        path: "/PrivacyPolicy",
        name: "BilGrosPrivacyPolicy",
        component: BilGrosPrivacyPolicy,
    },
    {
        path: "/PicPhone/PrivacyPolicy",
        name: "PicPhonePrivacyPolicy",
        component: PicPhonePrivacyPolicy,
    },
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});
router.beforeEach((to, from, next) => {
    if (
        (!window.VUE_APP_ENABLE_CREATE_ACCOUNT && to.name === "SignUp")
    ) {
        next({ name: "login" });
    }

    const loggedIn = localStorage.getItem("accessToken");
    if (
        (loggedIn && to.name === "login") ||
        (loggedIn && to.name === "ForgotPassword") ||
        (loggedIn && to.name === "ResetPassword") ||
        (loggedIn && to.name === "SignUp") ||
        (loggedIn && to.name === "VerifyEmail")
    ) {
        if (localStorage.getItem("accessMode")) {
            next({ name: "DelivryOrdersMenu" });
        } else {
            next({ name: "PurchaseOrder" });
        }
    }
    if (to.matched.some((record) => record.meta.auth) && !loggedIn) {
        next({ name: "login" });
        return;
    }
    next();
});
export default router;